import amplitude from 'amplitude-js';
import axios from 'axios';
import Cookies from 'js-cookie';
// import * as amplitudeModule from  '@amplitude/analytics-browser';

export const COMPONENT_NAMES = {
  growth_trends: '01 - Growth Trends',
  competitive_trends: '02 - Competitive Trends',
  ranking_factors: '03 - Ranking Factors',
  content_recommendations: '04 - Content Recommendations',
  usability_recommendations: '05 - Usability Recommendations',
  adhoc_analytics: '06 - Adhoc Analytics',
  internal_linking_recommendations: '07 - Internal Linking Recommendations',
  manage_urls: '08 - Manage URLs',
  manage_queries: '09 - Manage Queries',
  settings: '10 - Settings',
  opportunities: '11 - Opportunities',
  integrations: '12 - Integrations',
  create_content: '13 - Create Content',
  intent_management: '14 - Intent Management',
  category_management: '15 - Category Management',
  manage_list: '16 - Manage List',
  manage_rule: '17 - Manage Rule',
  plan_keywords: '18 - Plan Keywords',
  contentai_home: '19 - Content AI Home',
  contentai_ai_tools: '20 - Content AI Tools',
  autonomous_internal_linking: 'Autonomous Internal Linking',

  improve_keyword_relevance: 'Improve Keyword Relevance',
  improve_keyword_relevance_suggest_copy: 'Improve Keyword Relevance Suggest Copy',
  improve_content_quality: 'Improve Content Quality',
  improve_content_quality_suggest_copy: 'Improve Content Quality Suggest Copy',
};

export const CONTENT_AI_TOOL_NAME = {
  anchor_text_generator: 'Anchor Text Generator',
  active_passive_voice_converter: 'Active-Passive Converter',
  cluster_keywords: 'Cluster Keywords',
  keyword_statistics: 'Keyword Statistics',
  heading_rewriter: 'Heading Rewriter',
  h1_heading_generator: 'H1 Heading Generator',
  image_alt_text_generator: 'Image Alt Text Generator',
  meta_description_generator: 'Meta Description Generator',
  paragraph_rewriter: 'Paragraph Rewriter',
  paragraph_writer: 'Paragraph Generator',
  ai_text_generator: 'AI Text Generator',
  paraphrase_text: 'Paraphraser',
  seo_friendly_url_generator: 'SEO Friendly URL Generator',
  stepwise_instructions_generator: 'Stepwise Instructions Generator',
  summary_generator: 'Summary Generator',
  discover_topics: 'Discover Topics',
  content_brief_generator: 'Content Brief Generator',
  title_generator: 'Title Generator',
  free_keyword_research_tool: 'Keyword Research Tool',
};

export const CONTENT_AI_TOOL_CATEGORY = {
  free_seo_tools: 'Free SEO Tools',
  ai_content_writing_tools: 'AI Content Writing Tools',
  ai_content_optimization: 'AI Content Optimization',
  keyword_research: 'Keyword Research',
};

export const SCREEN_NAMES = {
  growth_trends: 'Growth Trends',
  competitive_trends: 'Competitive Trends',
  trends_watchlist: 'Trends Watchlist',
  ranking_factors: 'Ranking Factors',
  content_recommendations: 'Content Recommendations',
  paid_recommendations: 'Paid Recommendations',
  organic_recommendations: 'Organic Recommendations',
  usability_recommendations: 'Usability Recommendations',
  adhoc_analytics: 'Adhoc Analytics',
  internal_linking_recommendations: 'Internal Linking Recommendations',
  autonomous_internal_linking: 'Autonomous Internal Linking',
  manage_urls: 'Manage URLs',
  manage_queries: 'Manage Queries',
  settings: 'Settings',
  opportunity_explorer: 'Opportunity Explorer',
  top_opportunities: 'Top Opportunities',
  integrations: 'Integrations',
  add_new_page: 'Add New Page', //// optimized new page
  page_draft: 'Page Draft',
  keyword_list: 'Keywords List',
  intent_settings: 'Intent Settings',
  intent_keyword: 'Intent Keyword',
  category_setting: 'Category Settings',
  category_page: 'Category Page',
  entity_setting: 'Entity Settings',
  rule_setting: 'Rule Settings',
  connection_setting: 'Connection Settings',
  contentai_home_skip_gsc: 'Skip GSC',
  contentai_subscription_management: 'Content AI Subscription Management',
  contentai_ai_tools: 'Content AI Tools',
};
interface TrackEventOptions {
  isAddCount?: boolean;
  counterName?: string;
  eventName?: string;
  eventFor?: string;
  payload?: any;
  buttonText?: string;
  user?: any;
  isAnonymousUser?: boolean;
}

export const trackAnalyticsEvent = ({
  isAddCount = false,
  counterName = '',
  eventName = '',
  eventFor = 'Button',
  payload = {},
  buttonText = '',
  user = undefined,
  isAnonymousUser = false,
}: TrackEventOptions) => {
  try {
    let userEventName = eventName;
    const counterEventName = counterName ? counterName : `${payload?.label}`;
    // pass eventFor as non button if you want eventName as it is
    if (eventFor?.toLowerCase() === 'button') {
      userEventName = buttonText
        ? `${payload?.label ? payload.label + ' - ' : ''}${buttonText}${
            payload?.screen_name ? ' - ' + payload?.screen_name : ''
          }`
        : `${payload?.label || ''}${payload?.screen_name ? ' - ' + payload?.screen_name : ''}`;
    }
    if (isAddCount) {
      if (isAnonymousUser) {
        setPublicAccessUserAmplitudeInstance();
      }
      incrementCounterEvent(counterEventName, user);
    }
    if (window.analytics) {
      if (window.analytics.track) {
        let qttr_tools_daypass_auth = Cookies.get('qttr_tools_daypass_auth');
        if (qttr_tools_daypass_auth) {
          window.analytics.track(userEventName, {
            ...payload,
            is_day_pass_user: true,
          });
        } else {
          window.analytics.track(userEventName, {
            ...payload,
          });
        }
      }
    } else {
      segmentEventApi(userEventName, payload, 'track');
    }

    // Amplitude track event
    //  amplitudeModule.track(userEventName, payload);
  } catch (error) {
    console.error('trackEvent:: error::', error);
  }
};

const fetchIpAddress = async () => {
  try {
    const response = await fetch('https://api64.ipify.org?format=json');
    return await response.json();
  } catch (error) {
    console.error('Error fetching IP address:', error);
  }
};

export const segmentEventApi = async (userEventName, payload, endpoint) => {
  const getIp = await fetchIpAddress();
  const data = {
    anonymousId: getIp?.ip?.replace(/\./g, ''),
    userEventName,
    payload,
  };
  // Remove undefined properties from the data object
  const cleanData = Object.fromEntries(Object.entries(data).filter(([_, v]) => v !== undefined));
  //call segment server side
  axios.post(`${process.env.NEXT_PUBLIC_API_BASE_URL}/segment/${endpoint}`, cleanData);
};

//// Do not delet for now
// const incrementCount = (counterEventName) => {
//   try {
//     // using segmentio, but its use cach/storage from browser
//     // Retrieve current counts from user properties
//     const userProperties = window.analytics.user().traits();

//     const currentCount = userProperties[counterEventName] || 0;
//     const newCount = currentCount + 1;
//     userProperties[counterEventName] = newCount;

//     // Set the updated user properties
//     window.analytics.identify(userProperties);
//     return newCount;
//   } catch (error) {
//     console.error('incrementCount:: error::', error);
//   }
// };

export const setAmplitudeInstance = (email) => {
  // This is use for counter event
  amplitude.getInstance().init(process.env.NEXT_PUBLIC_AMPLITUDE_KEY, email);
};

export const setPublicAccessUserAmplitudeInstance = () => {
  if (window?.analytics) {
    if (window.analytics.user) {
      const deviceId = window.analytics.user().anonymousId();
      amplitude.getInstance().init(process.env.NEXT_PUBLIC_AMPLITUDE_KEY, null, {
        deviceId: deviceId,
      });
    }
  } else {
    segmentEventApi(null, null, 'identify');
  }
};

export const incrementCounterEvent = (counterEventName, user) => {
  if (user && user.email) {
    amplitude.getInstance().init(process.env.NEXT_PUBLIC_AMPLITUDE_KEY, null, {
      email: user.email,
    });
  }
  const identify =
    user && user.email
      ? new amplitude.Identify({ email: user.email }).add(counterEventName, 1)
      : new amplitude.Identify().add(counterEventName, 1);
  amplitude.getInstance().identify(identify);
};

export const setUserAttribute = (propertyName, value) => {
  setPublicAccessUserAmplitudeInstance();
  const identify = new amplitude.Identify().set(propertyName, value);
  amplitude.getInstance().identify(identify);
};

export const embedEventsToBeTracked = [
  'dashboard:loaded',
  'dashboard:run:start',
  'dashboard:run:complete',
  'dashboard:save:complete',
  'dashboard:edit:start',
  'dashboard:filters:changed',
  'look:run:start',
  'look:run:complete',
  'look:save:complete',
  // 'page:changed',
  'explore:loaded',
  'explore:run:start',
  'explore:run:complete',
  'explore:save:complete',
  'explore:edit:start',
  'explore:filters:changed',
];
